<template>
  <div id="app-container" class="active" :class="{ enlarged: !showNav }" :style="isFullWidth ? { width: '100%' } : {}">
    <component
      v-if="showLayout"
      :is="layout"
      :class="layoutClass"
    >
      <router-view :key="routerViewKey" class="page-container" />
    </component>
    <ServerErrorModal v-if="serverError" @close="clearServerError()"/>
    <restyle_alert :alerts="alerts" :darkTheme="darkTheme" :darkThemeRoutes="darkThemeRoutes" v-if="alerts.length > 0" />
    <resultCompleteTask v-if="isVisibleModalOMReport" @close="setIsVisibleModalOMReport(false)"  />
    <ReportTransporterValue v-if="isVisibleModalReportTransporterValue" @close="setIsVisibleModalReportTransporterValue(false)"/>
    <ReportWorkDrivers
    v-if="isVisibleModalReportWorkDrivers"
    @close="setIsVisibleModalReportWorkDrivers(false)"/>
    <ReportDelay
    v-if="isVisibleModalReportDelay"
    @close="setIsVisibleModalReportDelay(false)"
    />
    <ReroptNonExportAct v-if="isVisibleModalReportNonExportAct"
    @close="setIsVisibleModalReporNoNExportAct(false)"/>
    <ReroptDetailCalls v-if="isVisibleModalReportDetailCalls"
    @close="setIsVisibleModalReportDetailCalls(false)"/>
    <ReportGarbageTruckOccupancy v-if="isVisibleModalReportGarbageTruckOccupancy"
    @close="setIsVisibleModalReportGarbageTruckOccupancy(false)"/>
    <userNotifications v-if="isVisibleNotificationsPopup" />
    <baseTooltip
      v-if="view_tooltip"
      v-bind="view_tooltip"
    />

    <messengerComponent v-if="auth && userCan('show_chat')"/>
  </div>
</template>

<script>
// Login и ForgotPassword не трогать, решают баг с мельканием сайдбара при загрузке страницы.
import Login from "../src/pages/Auth/Login";
import ForgotPassword from "../src/pages/Auth/ForgotPassword.vue";
import ServerErrorModal from '@/components/error/ServerErrorModal.vue';
import { mapState, mapGetters, mapMutations } from "vuex";
const default_layout = "restyle";
import resultCompleteTask from '@/pages/reports/resultCompleteTask.vue';
import userNotifications from "@/components/restyle/popup/userNotifications.vue";
import { wbConnect } from "@/_helpers/wb-connect.js";
import messengerComponent from "@/components/helpers/messenger/index";
import ReportTransporterValue from "@/pages/reports/ReportTransporterEvaluation.vue";
import ReportWorkDrivers from "@/pages/reports/report-work-drivers.vue";
import ReportDelay from "@/pages/Report_delay/Report_delay.vue";
import ReroptDetailCalls from "@/pages/reports/ReroptDetailCalls.vue";
import ReroptNonExportAct from "@/pages/reports/NoNExportAct.vue"
import ReportGarbageTruckOccupancy from "@/pages/reports/ReportGarbageTruckOccupancy.vue";
import baseTooltip from "@/primitivesVue3/baseTooltip/baseTooltip.vue";

export default {
  name: "App",
  // Login и ForgotPassword не трогать, решают баг с мельканием сайдбара при загрузке страницы.
  components: {
    Login,
    ForgotPassword,
    ServerErrorModal,
    resultCompleteTask,
    userNotifications,
    ReportTransporterValue,
    ReportWorkDrivers,
    ReportDelay,
    ReroptNonExportAct,
    messengerComponent,
    ReroptDetailCalls,
    ReportGarbageTruckOccupancy,
    baseTooltip,
  },
  data() {
    return {
      showLayout: false,
      darkTheme: false,
      darkThemeRoutes: [
        'forgot-password',
        'reset-password',
        'login',
      ],
      isFullWidth: false,
      messageChatViewPageList: false,
    }
  },
  computed: {
    layoutClass() {
      let result = this.$route.meta.layoutClass;
      return result;
    },
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    ...mapState(["showNav", "userMenu"]),
    ...mapGetters({
      userCan: "user/userCan",
      allRoles: "roles/allRoles",
      rolesSRP: "roles/roles_SRP",
      user: "user/user",
      auth: "auth/auth",
      alerts: "alert/get_alerts",
      serverError: "error/serverError",
      view_tooltip: "tooltip_store/GET_VIEW_TOOLTIP",
      isVisibleModalOMReport: "reports/get_is_visible_modal_om_report",
      isVisibleNotificationsPopup: "user_notifications/GET_IS_VISIBLE_NOTIFICATIONS_POPUP",
      isVisibleModalReportTransporterValue: "reports/get_is_visible_modal_report_transporter_value",
      isVisibleModalReportWorkDrivers: "reports/get_is_visible_modal_report_work_drivers",
      isVisibleModalReportDelay: "reports/get_is_visible_modal_report_delay",
      isVisibleModalReportNonExportAct: "reports/get_is_visible_modal_report_non_export_act",
      isVisibleModalReportGarbageTruckOccupancy: "reports/get_is_visible_modal_report_garbage_truck_occupancy",
      routerViewKey: 'router_store/routerViewKey',
      isVisibleModalReportDetailCalls: "reports/get_is_visible_modal_report_detail_calls"
    }),
  },
  watch: {
    $route(to) {
      //showLayout решает баг с мельканием default layout-a при загрузке страницы
      if (!this.showLayout) {
        this.showLayout = true;
      }
      if (this.userMenu) this.$store.dispatch("close_user_menu");
      document.body.classList.remove("has-modal");

      if (!this.alerts.some((alert) => alert.sticky)) {
        this.$store.dispatch("alert/clear");
      }
      if (this.darkThemeRoutes.includes(to.name)) {
        this.darkTheme = true;
      } else {
        this.darkTheme = false;
      }

      document.title = to.meta.title == "Мобильные приложения для Android" ? "SmartRO" : to.meta.title;

      if (to.name === 'remove-account' || to.name === 'remove-account-confirm') {
        this.isFullWidth = true;
      } else {
        this.isFullWidth = false;
      }
    },
    user(newValue) {
      if (newValue?.id) {
        this.$store.dispatch("hotspots/getListActiveHotSpots")
        this.wbConnected()
      }
    }
  },
  beforeCreate() {
    let auth = localStorage.getItem("auth_token") !== null;
    if (!auth) {
      const publicPages = ["login", "forgot-password", "reset-password", "boss-app", "test_boss", "remove-account", "confirm"];
      const pathname = window.location.pathname.slice(1);
      const authRequired = !publicPages.some(page => pathname.startsWith(page));
      if (authRequired) {
        this.$router.push({
          name: "login",
          query: {
            redirect: window.location.pathname + window.location.search,
          },
        });
      }
    }
  },
  created() {
    this.deleteOldOmLocalStorage();
    if (this.auth) {
      if (this.userCan("role_read_all")) {
        this.$store.dispatch("roles/getRoles")
      };
      if (this.userCan("role_read_all")) {
        this.$store.dispatch("roles/getRolesSRP")
      };

      if (this.user?.id) {
        this.wbConnected()
      }
    }
    
    if (this.user?.id) {
      this.$store.dispatch("hotspots/getListActiveHotSpots")
    }
  },
  methods: {
    ...mapMutations({
      setIsVisibleModalOMReport: "reports/set_is_visible_modal_om_report",
      setIsVisibleModalReportTransporterValue: "reports/set_is_visible_modal_report_transporter_value",
      setIsVisibleModalReportWorkDrivers: "reports/set_is_visible_modal_report_work_drivers",
      setIsVisibleModalReportDelay: "reports/set_is_visible_modal_report_delay",
      setIsVisibleModalReporNoNExportAct: "reports/set_is_visible_modal_report_non_export_act",
      setIsVisibleModalReportDetailCalls: "reports/set_is_visible_modal_report_detail_calls",
      setIsVisibleModalReportGarbageTruckOccupancy: "reports/set_is_visible_modal_report_garbage_truck_occupancy",
    }),
    clearServerError() {
      this.$store.dispatch('error/clearServerError');
    },
    wbConnected() {
      const userID = JSON.parse(localStorage.getItem('user')).id;
      const wbUrlChannel = `notification-${userID}`;
      const wbEventName = 'NotificationEvent';

      this.$store.state.wbConnect.echo?.leave(wbUrlChannel);

      wbConnect().echoConnect();

      setTimeout(() => {
        const echo = this.$store.state.wbConnect.echo;
        if (echo) {
          wbConnect().echoOpenChannel(wbUrlChannel, wbEventName);

          document.addEventListener(wbUrlChannel, (event) => {
            this.$store.commit('user_notifications/SET_LIST_NOTIFICATIONS', event.detail);
          });
        }
      }, 500);
    },
    deleteOldOmLocalStorage() {
      if (localStorage.getItem('checkAutoLoad')) {
        localStorage.removeItem('checkAutoLoad');
      }
      if (localStorage.getItem('checkedReloadDate')) {
        localStorage.removeItem('checkedReloadDate');
      }
      if (localStorage.getItem('monitoring_filter_time')) {
        localStorage.removeItem('monitoring_filter_time');
      }
      if (localStorage.getItem('monitoring_organisation_id')) {
        localStorage.removeItem('monitoring_organisation_id');
      }
      if (localStorage.getItem('monitoring_filter_time')) {
        localStorage.removeItem('monitoring_filter_time');
      }
      if (localStorage.getItem('monitoring_waste_type_ids')) {
        localStorage.removeItem('monitoring_waste_type_ids');
      }
      if (localStorage.getItem('viewButtonVisibleAll')) {
        localStorage.removeItem('viewButtonVisibleAll');
      }
    },
  }
}; 
</script>

<style lang="scss"> 

@import "@/styles/variables.css";

@import url('https://fonts.googleapis.com/css?family=Noto+Sans:300,400,500,600,700');
@import url('https://fonts.googleapis.com/css2?family=Onest:wght@100..900');
@import "bootstrap/scss/bootstrap.scss";
@import "./assets/style/_base.scss";


body {
  --bs-body-font-family: "Noto Sans", sans-serif;
}
</style>